import React from 'react';
import { migrateTokens, isChromeExtension } from 'helpers';

/**
 * Token Migration
 * for users upgrading from 4.0.0, this moves their token
 * out of localStorage and into chromeStorage
 */
export const TokenMigration: React.FC = (props) => {
  const legacyTokensExist =
    isChromeExtension && localStorage.getItem('refreshToken') ? true : false;

  if (legacyTokensExist) {
    migrateTokens();
    return null;
  }

  return <>{props.children}</>;
};
